<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { useVModel } from '@vueuse/core';

const props = defineProps<{
	class?: HTMLAttributes['class'];
	defaultValue?: string | number;
	modelValue?: string | number;
	error?: string | boolean;
}>();

const emits = defineEmits<{
	(e: 'update:modelValue', payload: string | number): void;
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
	passive: true,
	defaultValue: props.defaultValue
});

const textareaRef = useTemplateRef<HTMLTextAreaElement>('textareaRef');

defineExpose({
	focus: () => textareaRef.value?.focus()
});
</script>

<template>
	<textarea
		ref="textareaRef"
		v-model="modelValue"
		:class="[
			cn(
				'flex min-h-[60px] w-full rounded-[2px] border border-white-dark-4 bg-transparent px-3 py-2 text-sm text-primary shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50',
				props.class
			),
			{ 'border-error!': props.error }
		]"
	></textarea>
</template>
